module.exports = __webpack_public_path__ + "static/media/emailInbox.0190c062.png";